import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuHideForEnvDirective } from '@shared/directives/au-hide-for-env.directive';
import { AuShowForEnvDirective } from '@shared/directives/au-show-for-env.directive';
import { AuHorizontalScrollDirective } from '@shared/directives/au-horizontal-scroll.directive';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { AuSwipeDirective } from '@shared/directives/au-swipe-directive';
import { AuMatInputAutofocusDirective } from 'app/shared/directives/au-mat-input-autofocus.directive';
import { AuScrollItemVisibleDirective } from './au-scroll-item-visible.directive';

export const DIRECTIVES_LIST = [
	AuHideForEnvDirective,
	AuShowForEnvDirective,
	AuHorizontalScrollDirective,
	ClickOutsideDirective,
	AuSwipeDirective,
	AuMatInputAutofocusDirective,
	AuScrollItemVisibleDirective,
];

@NgModule({
	imports: [CommonModule, ...DIRECTIVES_LIST],
	exports: [...DIRECTIVES_LIST],
})
export class AuDirectivesModule {}
